import { api } from "@api/api";
import { Code } from "@modules/codes/types";
import { CodeFormValues } from "@modules/codes/validations";

export async function editCodeService(id: string, data: Partial<CodeFormValues>): Promise<Code> {
  const { data: code } = await api.patch<Code>(`v1/limited_code_admin/${id}/`, data);

  return code;
}
